export default __webpack_public_path__ + "images/OU.b8a984b.png";